import styled from 'styled-components'

import { Colors } from '@sportsyou/core'

export const ContentHeader = styled.div`
  align-items: center;
  justify-content: space-between;
  display: flex;
  flex-direction: row;
  margin-bottom: 0.5rem;
  z-index: 10;
  background-color: #fff;
`

export const ContentHeaderItemRow = styled.div`
  align-items: center;
  display: flex;
  gap: 10px;
`

export const ContentHeaderRole = styled.div`
  font-size: 12px;
  text-transform: uppercase;
  white-space: nowrap;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5px 10px;
  border-radius: 5px;
  background-color: ${Colors.DUSTY_GRAY};
  color: ${Colors.WHITE};
  font-weight: bold;

  &:hover {
    &:before {
      content: 'Role:';
    }
  }
`

export const ContentHeaderTitle = styled.div`
  align-items: center;
  color: ${Colors.BLACK};
  display: flex;
  flex-direction: row;
  font-weight: bold;
  justify-content: space-between;
  margin-bottom: 0.5rem;

  a {
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
`
